import { render } from "./MainFooterComponent.vue?vue&type=template&id=54eb3110"
import script from "./MainFooterComponent.vue?vue&type=script&lang=js"
export * from "./MainFooterComponent.vue?vue&type=script&lang=js"
script.render = render

export default script